<!--
 * @Descripttion: 
 * @version: 
 * @Author: pengmiaopei
 * @Date: 2021-09-14 09:36:14
 * @LastEditors: pengmiaopei
 * @LastEditTime: 2021-11-03 13:49:11
 * @Description: file content
 * @FilePath: \Design_Vue_pmp\src\components\FileTree\index.vue
-->
<template>
  <div style="height:200px">
    <el-table :data="FileTree" :tree-props="defaultProps" row-key="id">
      <el-table-column prop="title" label="名称"></el-table-column>
      <!-- <el-table-column prop="fileName" label="修改/意见" width="100"></el-table-column> -->
    </el-table>
  </div>
</template>

<script>
  import { getAllData, getFileByInstanceId } from '@/api/01basicdata/filetype'
  import { GetFileTree } from '@/api/common'
  import { mapGetters } from 'vuex'
  import { treeData } from '@/utils'
  export default {
    computed: {
      ...mapGetters({
        projectId: 'user/projectId',
        prjInfo: 'user/prjInfo',
      }),
    },
    emits: ['selectItem'],
    data() {
      return {
        FileTree: [],
        defaultProps: {
          children: 'children',
          hasChildren: 'hasChildren',
        },
        instanceid: 'D421F10F-8FEE-46BF-A680-AE971230606B',
      }
    },
    created() {
      this.getFileTree()
    },
    methods: {
      async getFileTree() {
        let fileTypeList = (await getAllData()).result
        getFileByInstanceId(this.instanceid).then((res) => {
          for (let i = 0; i < fileTypeList.length; i++) {
            fileTypeList[i].children = []
            for (let index = 0; index < res.result.length; index++) {
              const element = res.result[index]
              if (element.fileTypeCode == fileTypeList[i].code) {
                element.title = element.fileName + '.' + element.fileExt
                fileTypeList[i].children.push(element)
              }
            }
          }

          this.FileTree = fileTypeList
        })
      },
    },
  }
</script>

<style>
  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #409eff;
    color: white;
  }
</style>
